// extracted by mini-css-extract-plugin
export default {"layer":"CustomDragLayer_layer__vOYRD","itemWrapper":"CustomDragLayer_itemWrapper__7KdBb"};